const gloDTGMonogramCodelist = {
    'DTGCoqBigPrint': {
        src: '//cdn.shopify.com/s/files/1/0635/8561/files/Floral_Circle_Abc.png?v=1707961046',
        code: 'U2FsdGVkX1/meTr+lX9+b4+pPZ1CYSrbqbxwkdgiAK8=',
    },
    'DTGMIYHearts': {
        src: '//cdn.shopify.com/s/files/1/0635/8561/files/Target_Chick_Amazon_MIY_Candy_Hearts.png?v=1704911067',
        code: 'U2FsdGVkX1/i/Eo2XmkFRB+tmd0RD9LkWyGi7XbdNMI=',
    },
    'DTGMIYHappiness': {
        src: '//cdn.shopify.com/s/files/1/0635/8561/files/' + dec('U2FsdGVkX1+AsPM8JLJG62hWFHnJzZHlAZ8A5kYJuLI=') + '.png?v=1707813135',
        code: 'U2FsdGVkX1+AsPM8JLJG62hWFHnJzZHlAZ8A5kYJuLI=',
    },

    'DTGBracelets': {
        src: '//cdn.shopify.com/s/files/1/0635/8561/files/' + dec('U2FsdGVkX19cfH1ZblH+9ufXrHx6bhWGlCPfzfG+llY=') + '.png?v=1699368354',
        code: 'U2FsdGVkX19cfH1ZblH+9ufXrHx6bhWGlCPfzfG+llY=',
    },
    'DTGChino': {
        src: '//cdn.shopify.com/s/files/1/0635/8561/files/' + dec('U2FsdGVkX1/+hAnFsmp7i40QPKXySDGZM95RKvv6knc=') + '.png?v=1685847818',
        code: 'U2FsdGVkX1/+hAnFsmp7i40QPKXySDGZM95RKvv6knc=',
        hideElements: true,
    },
    'DTGLate': {
        src: '//cdn.shopify.com/s/files/1/0635/8561/files/' + dec('U2FsdGVkX1/CYpOEe57h1F6SOGpaGJoX6utfHLXxlm8=') + '.png?v=1707813135',
        code: 'U2FsdGVkX1/CYpOEe57h1F6SOGpaGJoX6utfHLXxlm8=',
    },
    'DTGBows': {
        src: '//cdn.shopify.com/s/files/1/0635/8561/files/' + dec('U2FsdGVkX198Qkwz+7A+q4SoaBL8SsQ4ewcO/SbE1YI=') + '.png?v=1707813136',
        code: 'U2FsdGVkX198Qkwz+7A+q4SoaBL8SsQ4ewcO/SbE1YI=',
    },
    'DTGMIYBRB': {
        src: '//cdn.shopify.com/s/files/1/0635/8561/files/' + dec('U2FsdGVkX18Kfu2TXMSc/Tf6nPWKjBDNmOZPNFOPxiM=') + '.png?v=1707813135',
        code: 'U2FsdGVkX18Kfu2TXMSc/Tf6nPWKjBDNmOZPNFOPxiM=',
    },
    'DTGMIYFSoda': {
        src: '//cdn.shopify.com/s/files/1/0635/8561/files/' + dec('U2FsdGVkX1/cN22EZvoNTvTfdgJc2vhddPU1iQv81qs=') + '.png?v=1707813135',
        code: 'U2FsdGVkX1/cN22EZvoNTvTfdgJc2vhddPU1iQv81qs=',
    },
    'DTGMIYBusy': {
        src: '//cdn.shopify.com/s/files/1/0635/8561/files/' + dec('U2FsdGVkX1/5BcqwcMo++NHgA/jRffugiMyrHhc9+ME=') + '.png?v=1707813135',
        code: 'U2FsdGVkX1/5BcqwcMo++NHgA/jRffugiMyrHhc9+ME=',
    },
    'DTGMIYSocialClub': {
        src: '//cdn.shopify.com/s/files/1/0635/8561/files/Cool_Mom_Social_Club.png?v=1708096467',
        code: 'U2FsdGVkX1/CYM5UMLCrLHpHVvA8dKTkfDC97kdjyDaiqsM1192G2x5dAGW8mq5B=',
    },
    'DTGMIYYear': {
        src: '//cdn.shopify.com/s/files/1/0635/8561/files/' + dec('U2FsdGVkX1/V0pWmnaqfGvH8H4kYaAzPoD3bMosns5U=') + '.png?v=1707813135',
        code: 'U2FsdGVkX1/V0pWmnaqfGvH8H4kYaAzPoD3bMosns5U=',
    },

    'DTGCheckDogBowl': {
        src: '//cdn.shopify.com/s/files/1/0635/8561/files/' + dec('U2FsdGVkX1+Fm7VlvP/6tHlqV6YZnoH6qljcj/uIvAg=') + '.png?v=1707813135',
        code: 'U2FsdGVkX1+Fm7VlvP/6tHlqV6YZnoH6qljcj/uIvAg=',
    },



};